
  import { ref } from 'vue';
  import { Options, Vue } from 'vue-class-component';
  import { FilterMatchMode } from 'primevue/api';
  import Header from '@/components/Header.vue';
  import { AccountModule, AccountStore } from '@/store/account';
  import {
    MailSenderModule,
    MailSenderStore,
    MailSchedulerOption,
    MailSchedulerOptions,
    MailSchedulerRoutine,
    MailSchedulerRunResult,
    MailPreview
  } from '@/store/mailSender';

  @Options({
    components: {
      Header
    }
  })
  export default class MailSender extends Vue {
    private accountStore: AccountModule = AccountStore;
    private mailSenderStore: MailSenderModule = MailSenderStore;

    typeOptions = [
      { label: 'Newsletter', value: 'Newsletters' as MailSchedulerRoutine },
      { label: 'Announcement', value: 'Announcement' as MailSchedulerRoutine }
    ];

    options: MailSchedulerOptions = { newsletters: [], announcements: [] };
    selectedType: MailSchedulerRoutine | null = null;
    selectedIndex: number | null = null;
    send = false;

    loadingOptions = false;
    running = false;
    result: MailSchedulerRunResult | null = null;

    preview: MailPreview | null = null;
    loadingPreview = false;
    previewCollapsed = false;

    filters = ref({
      global: { value: null, matchMode: FilterMatchMode.CONTAINS }
    });

    get instanceOptions(): MailSchedulerOption[] {
      if (this.selectedType === 'Newsletters') {
        return this.options.newsletters;
      }
      if (this.selectedType === 'Announcement') {
        return this.options.announcements;
      }
      return [];
    }

    get canRun(): boolean {
      return !!this.selectedType && this.selectedIndex !== null && !this.running;
    }

    get recipientRows() {
      return this.result ? this.result.recipients.map((email) => ({ email })) : [];
    }

    onTypeChange() {
      this.selectedIndex = null;
      this.result = null;
      this.preview = null;
    }

    async onInstanceChange() {
      this.result = null;
      this.preview = null;
      this.previewCollapsed = false;

      if (this.selectedType === null || this.selectedIndex === null) {
        return;
      }

      this.loadingPreview = true;
      this.preview = await this.mailSenderStore.getPreview({
        routine: this.selectedType,
        index: this.selectedIndex
      });
      this.loadingPreview = false;
    }

    async onRun() {
      if (!this.canRun || this.selectedType === null || this.selectedIndex === null) {
        return;
      }

      this.running = true;
      this.previewCollapsed = true;
      this.result = await this.mailSenderStore.run({
        routine: this.selectedType,
        index: this.selectedIndex,
        send: this.send
      });
      this.running = false;
    }

    async mounted() {
      this.accountStore.initAuthDataFromLocalStorage();
      this.loadingOptions = true;
      this.options = await this.mailSenderStore.getOptions();
      this.loadingOptions = false;
    }
  }
